
function drip() {
    const dripSections = document.querySelectorAll('.Drip');
    dripSections.forEach(initDrip)
}

const drips = new Map(); 

function initDrip(section) {
    const $left = section.querySelector('.Drip-half--left');
    const $right = section.querySelector('.Drip-half--right');
    const $line = section.querySelector('.Drip-line');
    const $dot = section.querySelector('.Drip-dot');
    const $mask = section.querySelector('.Drip-line .Drip-mask');

    const radius = getRadius();

    const timeline = gsap.timeline({
        scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'top 25%',
        invalidateOnRefresh: true,
        scrub: true
        }
    });

    timeline.fromTo(
        $left,
        { borderTopRightRadius: '0' },
        { borderTopRightRadius: radius },
        0
    );

    timeline.fromTo(
        $right,
        { borderTopLeftRadius: '0' },
        { borderTopLeftRadius: radius },
        0
    );

    timeline.fromTo(
        $mask,
        { scaleY: '0', transformOrigin: '0 0' },
        { scaleY: '1' },
        '>'
    );

    if ($dot) {
        timeline.fromTo(
        $dot,
        { scale: '0.5', opacity: 0, transformOrigin: '50% 0' },
        { scale: '1', opacity: 1 },
        '>'
        );
    }

    const onResize = () => {
        timeline.invalidate();
    };

    window.addEventListener('breakpointChange', onResize);

    drips.set(section, {
        timeline,
        onResize
    });
}

function getRadius() {
    return '64px';
}

// function killDrip(section) {
//     const drip = drips.get(section);
//     if (drip) {
//         window.removeEventListener('breakpointChange', drip.onResize);
//         drip.timeline.kill();
//         drips.delete(section);
//     }
// }


